import { Injectable, OnDestroy, signal } from '@angular/core';
import { ElectronService } from '../electron.service';
import { IPC_CHANNEL } from './../_offline/electron.constants';

const {
  ZOOM_CONTROL: {
    SET_ZOOM,
    ZOOM_CHANGED
  }
} = IPC_CHANNEL;

@Injectable({
  providedIn: 'root'
})
export class ZoomControlService implements OnDestroy {

  private zoomStep = 0.05;

  zoomFactor = signal(1);

  constructor(private electronService: ElectronService) {
    this.registerZoomChangeListener();
  }

  private setZoom(factor: number) {
    const nextZoomFactor = Math.min(Math.max(factor, 0.25), 3);

    this.zoomFactor.set(nextZoomFactor);

    this.electronService.sendAsyncCommand(SET_ZOOM, nextZoomFactor);
  }

  private registerZoomChangeListener() {
    this.electronService.onEvent(ZOOM_CHANGED, (_event, [nextZoomFactor]) => {
      this.zoomFactor.set(nextZoomFactor);
    });
  }

  ngOnDestroy(): void {
    this.electronService.removeAllListeners(ZOOM_CHANGED);
  }

  resetZoom() {
    this.setZoom(1);
  }

  zoomIn() {
    this.setZoom(this.zoomFactor() + this.zoomStep);
  }

  zoomOut() {
    this.setZoom(this.zoomFactor() - this.zoomStep);
  }

}
